import { render, staticRenderFns } from "./scatterAnalysis.vue?vue&type=template&id=763b2e94&scoped=true&"
import script from "./scatterAnalysis.vue?vue&type=script&lang=js&"
export * from "./scatterAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./scatterAnalysis.vue?vue&type=style&index=0&id=763b2e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b2e94",
  null
  
)

export default component.exports